export default __webpack_public_path__ + "static/media/c_cloudez.a6c03abe.svg";